<h2 mat-dialog-title>{{'Crew settings' | translate}}</h2>
<mat-dialog-content class="mat-typography">
  <div class="example-container">
    <form [formGroup]="crewCardForm">
      <h3>{{'Crew card' | translate}}</h3>
      <mat-form-field appearance="fill">
        <mat-label>{{'Crew number' | translate}}</mat-label>
        <mat-select formControlName="crewNumber">
          <mat-option *ngFor="let number of numbers"
                      [value]="number">
            {{number}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <p>
        <mat-form-field appearance="fill">
          <mat-label>{{'Driver' | translate}}</mat-label>
          <mat-select formControlName="driver" [compareWith]="compareCompetitors">
            <mat-option value=""> {{'Select driver' | translate}} </mat-option>
            <mat-option *ngFor="let competitor of drivers"
                        [value]="competitor">
              {{competitor.firstName + ' ' + competitor.lastName}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="this.crewCardForm.get('driver').invalid">{{getErrorMessage(this.crewCardForm.get('driver')) | translate}}</mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>{{'Navigator' | translate}}</mat-label>
          <mat-select formControlName="navigator" [compareWith]="compareCompetitors">
            <mat-option value=""> {{'Select navigator' | translate}} </mat-option>
            <mat-option *ngFor="let competitor of navigators"
                        [value]="competitor">
              {{competitor.firstName + ' ' + competitor.lastName}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="this.crewCardForm.get('navigator').invalid">{{getErrorMessage(this.crewCardForm.get('navigator')) | translate}}</mat-error>
        </mat-form-field>
      </p>
      <h4 style="margin-bottom: 0">{{'Additional competitors' | translate}}</h4>
      <mat-list role="list">
        <mat-list-item role="listitem"
                       *ngFor="let competitor of additionalCompetitors">
          {{competitor.firstName + ' ' + competitor.lastName}}
          <button mat-icon-button
                  (click)="deleteAdditionalCompetitor(competitor)">
            <mat-icon>delete</mat-icon>
          </button>
        </mat-list-item>
      </mat-list>
      <mat-form-field appearance="fill" style="margin-top: 2%">
        <mat-label>{{'Additional competitor' | translate}}</mat-label>
        <mat-select formControlName="additionalCompetitor" [compareWith]="compareCompetitors">
          <mat-option value=""></mat-option>
          <mat-option *ngFor="let competitor of availableCompetitors"
                      [value]="competitor">
            {{competitor.firstName + ' ' + competitor.lastName}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-button color="primary"
              style="margin-left: 8px;"
              [disabled]="additionalCompetitorFieldIsEmpty()"
              (click)="processAvailableCompetitors()">
        {{'Add competitor' | translate}}
      </button>
    </form>
  </div>
</mat-dialog-content>
<mat-error *ngIf="serverIsDown">{{'Server problem, contact an administrator' | translate}}</mat-error>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{'Cancel' | translate}}</button>
  <button mat-button
          [disabled]="!crewCardForm.valid"
          (click)="onSaveCrew()">{{'Update crew' | translate}}</button>
</mat-dialog-actions>
